import { useContext } from 'react';
import { useSelector } from 'react-redux';
import { Banner, FlexContainer, ModalContext, Sizes, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { phoneSelector } from 'Store/modules/auth/selectors';
import { useTranslation } from 'Hooks/useTranslation';
import PhoneModal from 'Components/Modal/components/PhoneModal';
import { lottiesPaths } from 'Constants/lottiesPaths';
import { TaxScreenType } from 'Types/common';
import * as Styled from '../styles';

const RetrievalInfo = ({ tax }: TaxScreenType): JSX.Element => {
  const { t } = useTranslation(locizeNS.DASHBOARD);
  const { showModal } = useContext(ModalContext);
  const phoneSaved = useSelector(phoneSelector);
  const { taxYear } = tax;

  const handleOpenPhoneNumberModal = (): void => {
    showModal({
      comp: <PhoneModal />,
    });
  };

  return (
    <FlexContainer fullHeight direction="column" align="center" gap="dimension_32">
      {!phoneSaved && (
        <Banner
          id="retrieval-info-banner"
          label={t(`TaxScreen.RetrievalInfo.banner.not.phone`)}
          description={t(`TaxScreen.RetrievalInfo.banner.description`)}
          mode="warning"
          layout="embed"
          position="vertically"
          hasIcon
          size={Sizes.S}
          titleSize={Sizes.S}
          buttonLabel={t('TaxScreen.RetrievalInfo.banner.button')}
          onClick={handleOpenPhoneNumberModal}
        />
      )}
      <FlexContainer
        fullHeight
        direction="column"
        align="center"
        justify="center"
        gap="dimension_08"
      >
        <Text size="L_L_S" color="dark" type="headline">
          {taxYear}
        </Text>
        <Text type="paragraphs" size="L_L_M" color="dark" align="center">
          {t('TaxScreen.RetrievalInfo.title')}
        </Text>
        <Styled.StyledLottie
          options={{
            path: lottiesPaths.DASHBOARD_DATA_RETRIEVAL,
            rendererSetting: { progressiveLoad: true },
          }}
        />
        <Text type="paragraphs" color="dark" size="M_L_S" align="center">
          {t(`TaxScreen.RetrievalInfo.info`)}
        </Text>
        <Text type="paragraphs" color="dark" size="S_S_S" align="center">
          {t(`TaxScreen.RetrievalInfo.description`)}
        </Text>
      </FlexContainer>
      {phoneSaved && (
        <Banner
          id="retrieval-info-banner"
          label={t(`TaxScreen.RetrievalInfo.banner`, {
            phone: phoneSaved,
          })}
          mode="default"
          layout="embed"
          buttonLabel={t('TaxScreen.RetrievalInfo.banner.modify.button')}
          onClick={handleOpenPhoneNumberModal}
        />
      )}
    </FlexContainer>
  );
};

export default RetrievalInfo;
